import { EventEmitter, Injectable } from '@angular/core';
import { Tenant } from '../../store/reviewer/reviewer.interface';
import { StorageService } from './storage.service';
import { MessagingCountHash } from '../../modules/client/dashboard/message/message.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmittersService {
  tenantEmitter:EventEmitter<Tenant> = new EventEmitter();
  searchMarketSelectorEmitter: EventEmitter<any> = new EventEmitter();
  skillAndExperienceEmitter: EventEmitter<any> = new EventEmitter();
  credentialEmitter: EventEmitter<any> = new EventEmitter();
  myProjectEmitter: EventEmitter<boolean> = new EventEmitter();
  reviewerListEmitter: EventEmitter<void> = new EventEmitter();
  staffTabEmitter: EventEmitter<void> = new EventEmitter();
  messageCountEmitter: BehaviorSubject<MessagingCountHash> = new BehaviorSubject<any>({});
  reviewerMessageFromFirmCountEmitter: BehaviorSubject<MessagingCountHash> = new BehaviorSubject<any>({});
  todoListEmitter: EventEmitter<void> = new EventEmitter();
  isCurrentlyAssignedEmitter: EventEmitter<void> = new EventEmitter();

  constructor(private storageService:StorageService) {
    this.tenantEmitter.subscribe((event)=>{
        this.storageService.setTenant(event);
    });
    this.searchMarketSelectorEmitter.subscribe((event)=>{
      if(event){
        this.storageService.setSelectedSearchMarkets(event);
      }
    });
   }
}
